import { useState } from "react";
import AgroMHistoryCard from "../AgroMCard/AgroMHistoryCard";
import AgroMCard from "../AgroMCard/AgroMCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { COLORS } from "../../utils/Colors";
import { AgroComponentProps } from "../../types/propsTypes";

const AgroComponent = ({ polyid, lat, lng, setPolyid }: AgroComponentProps) => {
    const [activeTab, setActiveTab] = useState("weather");

    if (polyid === null) return null;

    return (
        <div className="flex absolute z-10 top-16 left-1/2 transform flex-col bg-white w-1/3 rounded-xl">

            <div className="flex w-full justify-around border-b rounded-xl border-gray-500" style={{ background: COLORS.Brand }}>
                <button
                    className={`py-2 px-4 text-white ${activeTab === "weather" ? "border-b-2 border-red-500" : ""}`}
                    onClick={() => setActiveTab("weather")}>
                    Weather
                </button>
                <button
                    className={`py-2 px-4 text-white ${activeTab === "nvdi" ? "border-b-2 border-red-500" : ""
                        }`}
                    onClick={() => setActiveTab("nvdi")}>
                    NVDI
                </button>
                <button
                    className={`py-2 px-4 text-white ${activeTab === "soil" ? "border-b-2 border-red-500" : ""
                        }`}
                    onClick={() => setActiveTab("soil")}>
                    Soil
                </button>
                <div className="flex w-1/3 justify-end items-center text-2xl hover:cursor-pointer" >
                    <FontAwesomeIcon onClick={() => { setPolyid(null) }} className="w-5 h-5 pr-2" color="white" icon={faClose} />

                </div>
            </div>

            <div className="flex flex-col w-full h-full border" style={{ borderRadius: '10px' }}>

                <AgroMCard polygonId={polyid} type={activeTab} />

                <AgroMHistoryCard
                    polygonId={polyid}
                    lat={lat?.toString()!}
                    lng={lng.toString()!}
                    type={activeTab}
                />
            </div>

        </div>
    );
};

export default AgroComponent;
